export default {
  paragraphs: [
    {
      fullParagraph: {
        topic: {},
        title: "346%",
        body: "return on investment (ROI) over three years"
      }
    },
    { fullParagraph: { topic: {}, title: "$127K", body: "increase in creative team productivity" } },
    { fullParagraph: { topic: {}, title: "$279K", body: "net present value (NPV) over three years" } }
  ]
};
